//React
import { FunctionComponent, useEffect } from "react";

//App Hooks
import { useAppSelector } from "../../../system/redux/hooks/redux-store-hooks";

//Selectors
import { selectAreaInfo } from "../../redux/selectors/select-area-info";
import { selectIsAppLoaded } from "../../../system/redux/selectors/select-app-loaded";

//Util
import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";
import { selectUserInteractedWithMap } from "../../../map/redux/selectors/select-user-interacted-with-map";

/** Updates the path of the URL when we get the area info url from the API. */
export const UrlManagerAreaInfo: FunctionComponent = (props) => {
	//State Values
	const appLoaded = useAppSelector(selectIsAppLoaded);

	const areaInfo = useAppSelector(selectAreaInfo);
	const userInteractedWithMap = useAppSelector(selectUserInteractedWithMap);

	//Use Effects
	useEffect(() => {
		//If the user has not moved the map yet then just leave the URL as is or if the app has not
		// fully been loaded.
		if (!userInteractedWithMap || !appLoaded) {
			return;
		}

		if (window.history.pushState) {
			var urlParts = window.location.href.split("#");

			var host = window.location.protocol + "//" + window.location.host;

			let newTitle = "New Build Homes | D.R. Horton";
			let newUrl = "/community-finder";

			if (!isStringEmpty(areaInfo?.Url)) {
				newTitle = "New Build Homes in " + areaInfo?.Name + " | D.R. Horton";

				newUrl = host + areaInfo?.Url + window.location.search;
			}

			//If the URL has not changed do not do anything
			if (newUrl === window.location.href || newUrl === undefined) {
				return;
			}

			//Update the Title
			document.title = newTitle;

			//Update the URL
			window.history.pushState(
				newTitle,
				newTitle,
				window.location.href.replace(urlParts[0], newUrl),
			);
		}
	}, [areaInfo, appLoaded]);

	return null;
};
